module.exports = __webpack_public_path__ + "5ac883e7e876359316293fcc26506500.svg";